@let info = this.info();

@if (info?.isVisible) {
  <div [id]="cardId()" class="mt-7">
    <mwe-basic-card [iconClass]="info.iconClass" [cardTitle]="info.title" [headingNodeType]="'h2'">
      <p [innerHTML]="info.text"></p>
      <mwe-button class="d-block" color="blue" [buttonId]="buttonId()" [labelKey]="info.btn" (clicked)="startProcess()" />
    </mwe-basic-card>
  </div>
}
